const initalState = {
    authorizedPersons: [{
        name: '',
        surname: '',
        dateOfBirth: '',
        citizenship: '',
        email: '',
        phone: '',
        id: ''
    }]
}


export const authorizedPersons = (state = initalState.authorizedPersons, action) => { 
    switch (action.type) {
        case 'AUTHORIZED_PERSONS_CHANGE':
            return action.value;      
        default:
            return state
    }
}
